const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const toECRIDateFormat = (d: Date) => {
  const date = d.getDate();
  const datestr = date < 10 ? '0' + date : date;
  return `${monthNames[d.getMonth()]} ${datestr}, ${d.getFullYear()}`;
};

export const ToECRITimeFormat = (d: Date) => {
  const minutes = d.getMinutes();
  const seconds = d.getSeconds();
  let hours = d.getHours();
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutesStr = minutes < 10 ? '0' + minutes : minutes;
  const secondsStr = seconds < 10 ? '0' + seconds : seconds;
  return `${hours}:${minutesStr}:${secondsStr} ${hours >= 12 ? 'PM' : 'AM'}`;
};

export const convertTimeStampToLastLoginDate = (timestamp: number) => {
  const d = new Date(timestamp * 1000);
  const yyyy = d.getFullYear();
  const dd = ('0' + d.getDate()).slice(-2);
  const hh = d.getHours();
  let h = hh;
  const min = ('0' + d.getMinutes()).slice(-2);
  let ampm = 'AM';

  if (hh > 12) {
    h = hh - 12;
    ampm = 'PM';
  } else if (hh === 12) {
    h = 12;
    ampm = 'PM';
  } else if (hh === 0) {
    h = 12;
  }

  return `Your last login was ${
    monthNames[d.getMonth()]
  } ${dd}, ${yyyy} at ${h}:${min} ${ampm}`;
};
